import {TimeSpan} from "@sparkware/app-utils";
import {Button} from "../../../basic-ui-components/button/base/button.component";
import {DividerBox} from "../../../basic-ui-components/layout/divider/divider.box";
import {SpacerBox} from "../../../basic-ui-components/layout/spacer.box";
import {useServices} from "../../../react-hooks/use-services.hook";
import {IModalDialogHandler} from "../../../services/dialog/dialog.service.interface";
import {GamblingSessionMessageBaseBox} from "../boxes/gambling-session-message.box";
import {GamblingSessionLimitSummaryBox} from "../session-info/boxes/gambling-session-limits-summary.box";
import {GamblingSessionInfoComponent} from "../session-info/gambling-session-info.component";

export enum LimitType {
    Loss,
    Time,
    IntervalReminder
}

interface IGamblingSessionLimitReachedComponentProps {
    sessionDuration: TimeSpan;
    limitType: LimitType;
    totalBets: number;
    totalWins: number;
    dialogHandler: IModalDialogHandler;

    sessionLimitTimestamp: string;
}

export const GamblingSessionLimitReachedComponent: React.FC<IGamblingSessionLimitReachedComponentProps> = (props) => {
    const services = useServices();
    let mainTextKey = "GAMBLING_SESSION_INTERVAL_REMINDER_TEXT";
    if (props.limitType === LimitType.Loss) {
        mainTextKey = 'GAMBLING_SESSION_LOSS_LIMIT_REACHED_TEXT';
    }
    if (props.limitType === LimitType.Time) {
        mainTextKey = 'GAMBLING_SESSION_TIME_LIMIT_REACHED_TEXT';
    }
    return (
        <GamblingSessionLimitSummaryBox>
            <GamblingSessionMessageBaseBox>
                { services.translation.translate(mainTextKey, {
                    gamblingSessionLimitTimestamp: props.sessionLimitTimestamp
                }) }
            </GamblingSessionMessageBaseBox>
            <DividerBox />
            <SpacerBox height="1.5rem"/>

            <GamblingSessionInfoComponent
                sessionDuration={props.sessionDuration}
                totalWins={props.totalWins}
                totalBets={props.totalBets}
            />

            <div>
                <Button preset={"primary"} onClick={() => props.dialogHandler.close()} margin="2rem auto 0">
                    {services.translation.translate("OK")}
                </Button>
            </div>

        </GamblingSessionLimitSummaryBox>
    );
};